import React from 'react';
import SettingsIconSelectInput from '../../../ui/inputs/SettingsIconSelectInput';
import { useTranslation } from 'react-i18next';
import SquareColorInput from '../../../ui/inputs/SquareColorInput';
import CustomSVGs from '../../../ui/customSVGs/CustomSVGs';
import { crossSVG } from '../../../lib/allCustomSVGs';
import '../../../styles/pages/notifications/metricSelection.scss';

type Props = {
  color: string;
  setColor: (color: string) => void;
  colorType: string;
  setColorType: (type: string) => void;
  integrationType: string;
  metricName: string;
  index: number;
  removeMetric: (index: number) => void;
};

const MetricSelection = ({
  color,
  setColor,
  colorType,
  setColorType,
  integrationType,
  metricName,
  index,
  removeMetric,
}: Props) => {
  const { t } = useTranslation();
  return (
    <div className='metricSelection'>
      <div className='metricSelection__left'>
        {colorType === 'custom' && (
          <div
            className='metricSelection__left--color'
            style={{ backgroundColor: color }}
          ></div>
        )}
        <div className='metricSelection__left--title'>{`${integrationType} • ${metricName}`}</div>
      </div>
      <div className='metricSelection__right'>
        <SettingsIconSelectInput
          filterOptions={[
            { text: t('Auto'), value: 'auto', icon: null },
            { text: t('Custom'), value: 'custom', icon: null },
          ]}
          marginTop='0rem'
          value={colorType}
          onFilterChange={(val) => setColorType(val)}
        />

        {colorType === 'custom' && (
          <SquareColorInput
            id={`metricColor-${metricName}`}
            setValue={setColor}
            value={color}
          />
        )}

        <div
          className='metricSelection__right--remove'
          onClick={() => removeMetric(index)}
          title={t('RemoveMetric') || 'Remove metric'}
        >
          <CustomSVGs svg={crossSVG} />
        </div>
      </div>
    </div>
  );
};

export default MetricSelection;
